export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Regular.42278116.woff2";